<template>
  <a data-test-id="buttonLink" v-bind="$attrs" class="button-link d-print-none">
    <v-icon style="margin-right: 0.5rem" :icon="icon" />&nbsp;
    <span class="link-text"> {{ label }}</span>
  </a>
</template>

<script setup lang="ts">
// STORES, IMPORTS, & COMPOSABLES

// PROPS & EMITS
defineProps({
  icon: { type: String, required: true },
  label: { type: String, required: true }
})

// REACTIVE VARIABLES

// COMPUTED PROPERTIES

// LIFECYCLE HOOKS

// FUNCTIONS
</script>

<style lang="scss" scoped>
.button-link {
  color: $color-text-primary;
  text-decoration: none;
}
.button-link:hover {
  color: $color-main-primary;
}

.link-text {
  text-decoration: none;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
  font-size: 0.75rem;
}
</style>
